// extracted by mini-css-extract-plugin
export default {"l":"b2b1ca9e65"};